export const EN_TO_ES: Record<string, string> = {
  Account: 'Cuenta',
  'Account Name': 'Nombre de la Cuenta',
  Accounting: 'Contabilidad',
  'Accounting overview': 'Resumen Contable',

  'Accounts Payable': 'Cuentas por pagar',
  'Accounts Payable (A/P)': 'Cuentas por Pagar (A/P)',
  'Accounts Receivable': 'Cuentas por Cobrar',
  'Accounts Receivable (A/R)': 'Cuentas por Cobrar (A/R)',

  'Accumulated Adjustments': 'Ajustes Acumulados',
  'Add Account': 'Agregar Cuenta',
  'Add opening balance': 'Agregar Saldo Inicial',

  All: 'Todo',
  'All transactions will be displayed here once reviewed':
    'Todas las transacciones se mostrarán aquí una vez revisadas',
  'All uncategorized transactions will be displayed here':
    'Todas las transacciones sin categorizar se mostrarán aquí',

  Amount: 'Importe',

  Apr: 'Abr',
  Aug: 'Ago',

  Assets: 'Activos',
  Balance: 'Saldo',
  'Balance Sheet': 'Balance General',

  'Bank Accounts': 'Cuentas Bancarias',
  'Bank Transactions': 'Transacciones',
  'Bank balance': 'Saldo Bancario',
  'Bank transactions': 'Transacciones',
  Banking: 'Banca',

  'Business Insurance': 'Seguro Empresarial',
  'Business Meals': 'Comidas de Negocios',
  'Business Travel': 'Viajes de Negocios',

  COGS: 'Costo de ventas',
  Cash: 'Efectivo',

  Catalog: 'Catálogo',
  Categorize: 'Clasificar',
  Categorized: 'Categorizado',
  Category: 'Categoría',

  'Chart of Accounts': 'Catálogo de Cuentas',
  'Collected Tips': 'Propinas Recolectadas',

  'Collapse all rows': 'Contraer todas las filas',
  Confirm: 'Confirmar',
  Contributions: 'Contribuciones',
  'Cost of Goods Sold': 'Costo de los Bienes Vendidos',

  'Credit Cards': 'Tarjetas de Crédito',
  Customers: 'Clientes',
  'Current Assets': 'Activos Corrientes',
  'Current Liabilities': 'Pasivos Corrientes',
  'Non-current Assets': 'Activos no Corrientes',
  'Non-current Liabilities': 'Pasivos no Corrientes',
  'Total of Assets': 'Total de Activos',
  'Total of Liabilities': 'Total de Pasivos',
  'Total of Current Assets': 'Total de Activos Corrientes',
  'Total of Current Liabilities': 'Total of Pasivos Corrientes',
  'Liabilities and Equity': 'Pasivos y Patrimonio',
  'Total of Equities': 'Total de Patrimonio',
  'Total of Liabilities and Equity': 'Total de Pasivos y Patrimonio',

  Date: 'Fecha',
  Dec: 'Dic',

  'Development Costs': 'Costos de desarrollo',
  Distributions: 'Distribuciones',

  Download: 'Descargar',
  'Download CSV': 'Descargar CSV',

  Equities: 'Patrimonios',
  Equity: 'Patrimonio',

  'Expand all rows': 'Expandir todas las filas',
  Expenses: 'Gastos',

  Feb: 'Feb',
  Fees: 'Honorarios',
  Filters: 'Filtros',

  'Fixed Assets': 'Activos Fijos',
  Fuel: 'Combustible',

  'General Ledger': 'Libro Mayor',
  'Gross Profit': 'Utilidad Bruta',

  Inventory: 'Inventario',
  Invoices: 'Facturas',

  Jan: 'Ene',
  Journal: 'Diario',

  Jul: 'Jul',
  Jun: 'Jun',

  Liabilities: 'Pasivos',
  'Lines of Credit': 'Líneas de Crédito',
  'Linked Accounts': 'Cuentas Vinculadas',

  Mar: 'Mar',
  Marketing: 'Marketing',
  May: 'May',

  'Net Profit': 'Utilidad Neta',
  'Notes Payable': 'Documentos por Pagar',

  Nov: 'Nov',
  'Nov 1, 2025': '1 Nov 2025',
  'Nov 10, 2025': '10 Nov 2025',
  'Nov 12, 2025': '12 Nov 2025',
  'Nov 2, 2025': '2 Nov 2025',
  'Nov 4, 2025': '4 Nov 2025',
  'Nov 6, 2025': '6 Nov 2025',
  'Nov 7, 2025': '7 Nov 2025',
  'Nov 8, 2025': '8 Nov 2025',
  'Nov 9, 2025': '9 Nov 2025',
  'January 2025': 'Enero 2025',
  'January, 2025': 'Enero, 2025',
  'February 2025': 'Febrero 2025',
  'February, 2025': 'Febrero, 2025',
  'March 2025': 'Marzo 2025',
  'All done': 'Todo listo',
  'March, 2025': 'Marzo, 2025',
  'April 2025': 'Abril 2025',
  'April, 2025': 'Abril, 2025',
  'May 2025': 'Mayo 2025',
  'May, 2025': 'Mayo, 2025',
  'June 2025': 'Junio 2025',
  'June, 2025': 'Junio, 2025',
  'July 2025': 'Julio 2025',
  'July, 2025': 'Julio, 2025',
  'August 2025': 'Agosto 2025',
  'August, 2025': 'Agosto, 2025',
  'September 2025': 'Septiembre 2025',
  'September, 2025': 'Septiembre, 2025',
  'October 2025': 'Octubre 2025',
  'October, 2025': 'Octubre, 2025',
  'November 2025': 'Noviembre 2025',
  'November, 2025': 'Noviembre, 2025',
  'December 2025': 'Diciembre 2025',
  'December, 2025': 'Diciembre, 2025',

  Oct: 'Oct',
  Office: 'Oficina',
  'Office Expenses': 'Gastos de Oficina',

  'Opening Balance Equity': 'Patrimonio de Saldo Inicial',
  'Operating Expenses': 'Gastos Operativos',

  'Other Revenue': 'Otros Ingresos',
  'Other Taxes Payable': 'Otros Impuestos por Pagar',

  Overview: 'Resumen',

  'Payment Clearing Accounts': 'Cuentas de Compensación de Pagos',
  'Payment Processor Clearing Accounts':
    'Cuentas de Compensación de Procesadores de Pago',
  'Payment Processing Fees': 'Tarifas de Procesamiento de Pagos',

  'Payroll Liabilities': 'Pasivos de Nómina',
  'Prepaid Expenses': 'Gastos Pagados por Adelantado',

  'Profit & Loss': 'Estado de Resultados',
  'Profit Before Taxes': 'Utilidad Antes de Impuestos',

  'Refund Liabilities': 'Pasivos por Reembolsos',

  Rent: 'Alquiler',
  Reports: 'Reportes',
  'Retained Earnings': 'Utilidades Retenidas',

  'Returns & Allowances': 'Devoluciones y Bonificaciones',
  'Returns and Allowances': 'Devoluciones y Bonificaciones',

  Revenue: 'Ingresos',
  Sales: 'Ventas',
  'Sales Taxes Payable': 'Impuestos Sobre Ventas por Pagar',

  'Search transactions': 'Buscar transacciones',
  Sep: 'Sep',

  'Shareholder Loans': 'Préstamos de Accionistas',

  'Statement of Cash Flow': 'Estado de Flujo de Efectivo',

  'Operating Activities': 'Actividades Operativas',
  'Net Income': 'Utilidad Neta',
  'Adjustments to Net Income': 'Ajustes a la Utilidad Neta',
  'Total of Adjustments to Net Income': 'Total de Ajustes a la Utilidad Neta',
  'Total of Operating Activities': 'Total de Actividades Operativas',

  'Investing Activities': 'Actividades de Inversión',
  'Financing Activities': 'Actividades de Financiación',

  'Net Cash Increase For Period': 'Aumento Neto de Efectivo del Período',
  'Cash at Beginning of Period': 'Efectivo al Inicio del Período',
  'Cash at End of Period': 'Efectivo al Final del Período',

  'Search accounts': 'Buscar cuentas',
  'Sub-Type': 'Subtipo',

  Taxes: 'Impuestos',
  'Taxes & Licenses': 'Impuestos y Licencias',

  'This Month': 'Este Mes',
  'Last Month': 'El Mes Pasado',
  'This Quarter': 'Este Trimestre',
  'Last Quarter': 'El Trimestre Pasado',
  'This Year': 'Este Año',
  'Last Year': 'El Año Pasado',

  Tips: 'Propinas',

  'To Review': 'Para revisar',
  Total: 'Total',

  Transaction: 'Transacción',
  Transactions: 'Transacciones',
  'Transactions to review': 'Transacciones para Revisar',

  Type: 'Tipo',

  Uncategorize: 'Desclasificar',
  Uncategorized: 'Sin Categorizar',
  Recategorize: 'Reclasificar',
  'Uncategorized Revenue': 'Ingresos sin Categorizar',

  'Undeposited Funds': 'Fondos no Depositados',
  'Undeposited Outflows': 'Salidas no Depositadas',
  'Undeposited Payments': 'Pagos no Depositados',

  'Unearned Revenue': 'Ingresos no Devengados',

  Utilities: 'Servicios Públicos',

  Value: 'Valor',
  'Vehicle Expenses': 'Gastos de Vehículo',

  'You are up to date with transactions!':
    '¡Estás al día con las transacciones!',
  'You have no categorized transactions':
    'No tienes transacciones categorizadas',

  pending: 'pendiente',
}
